import React from "react"
import CCOCard from "../../fundamentals/CCOCard";
import {metaDataElementWithId} from "../../preview/previewMetaData";
import {usePreviewContext} from "../../../context/PreviewContext";
import TeaserCardContent from "./TeaserCardContent";
import {CallToActionType} from "./TeaserCardCallToAction";

interface DescriptionLimitMeta {
    value?: number;
    source?: 'default' | string;
    ownerId?: string;
}

interface Props {
    borderWidth?: string
    customStyle?: any
    hero?: boolean
    hideShowMoreButton?: boolean
    horizontal?: boolean
    item: any
    padding?: number
    pill?: string
    headlineType?: string
    descriptionLimit?: DescriptionLimitMeta
    hideRoofline?: boolean
    teasercardLocation?: string
    hasPriority?: boolean
    showAiGeneratedImageLabel?: boolean
}

export function isTargetCMDownload(item: any) {
    return item.type === 'SOSFilterTeaser' && item.teaserTarget?.type === 'CMDownload'
}

function TeaserCard(props: Props) {
    const isPreview = usePreviewContext().isPreview;
    const padding = props.padding ? props.padding : 0;
    if (props.item != null) {
        const hideShowMoreButton = props.hideShowMoreButton || !props.item.teaserTarget;
        const noLink = !props.item.teaserTarget;
        return <CCOCard dataCypress={'teaserCard'}
                        teasercardLocation={props.teasercardLocation}
                        border={props.hero}
                        customStyle={props.customStyle}
                        item={props.item}
                        padding={padding}
                        isTargetCMDownload={isTargetCMDownload(props.item)}
                        noLink={noLink}
                        hasFocusedStyle {...metaDataElementWithId(isPreview, props.item.id)}>
            <TeaserCardContent item={props.item}
                               pill={props.pill} hero={props.hero}
                               horizontal={props.horizontal}
                               descriptionLimit={props.descriptionLimit}
                               callToActionType={hideShowMoreButton ? undefined : CallToActionType.TEXT}
                               hideRoofline={props.hideRoofline}
                               hasPriority={props.hasPriority}
                               showAiGeneratedImageLabel={props.showAiGeneratedImageLabel}
            />
        </CCOCard>
    } else {
        return null
    }
}

export default TeaserCard
